import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  height: "48",
  width: "48",
  class: "yb-svg-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M22,0H2A2,2,0,0,0,0,2V22a2,2,0,0,0,2,2H22a2,2,0,0,0,2-2V2A2,2,0,0,0,22,0ZM6.5,14a2,2,0,1,1,2-2A2,2,0,0,1,6.5,14ZM12,14a2,2,0,1,1,2-2A2,2,0,0,1,12,14Zm5.5,0a2,2,0,1,1,2-2A2,2,0,0,1,17.5,14Z",
      fill: "currentColor"
    }, null, -1)
  ])))
}
export default { render: render }